import styled from "styled-components";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";

export const Container = styled.div`
  display: flex;
  color: ${({ theme }) => theme.orangeBackground};
  font-size: 12px;
`;

export const StyledFormControl = styled(Form.Control)`
  width: 129px;
  height: 29px;
  font-size: 12px;
`;

export const StyledInputGroupText = styled(InputGroup.Text)`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.25rem 0 0 0.25rem;
  border-right: 0;
  width: 29px;
  height: 29px;
  background-color: #AFAFAF;
  
  svg, path {
    fill: #FFF;
  }
`;
